import { InputStyleType } from 'primereact/api';

import { getLocalStorage, setLocalStorage } from '@/utils/storage';

export enum PreferencesActions {
  UPDATE_SHOW = 'preferences/UPDATE_SHOW',
  UPDATE_MODE = 'preferences/UPDATE_MODE',
  UPDATE_SCALE = 'preferences/UPDATE_SCALE',
  UPDATE_COMPACT_GRID = 'preferences/UPDATE_COMPACT_GRID',
}

export enum Mode {
  LIGHT = 'light',
  DARK = 'dark',
}

export type PreferencesType = {
  show: boolean;
  inputStyle: InputStyleType;
  mode: Mode;
  previousTheme: string;
  ripple: boolean;
  scale: number;
  theme: string;
  compactGrid: boolean;
};

const defaultState: PreferencesType = {
  show: false,
  inputStyle: 'outlined',
  mode: Mode.LIGHT,
  previousTheme: 'mira',
  ripple: true,
  scale: 13,
  theme: 'mira',
  compactGrid: false,
};

// Theme, input style and ripple are no longer user settings, so stored values
// for them are ignored. The drawer always starts closed.
export const initialState: PreferencesType = {
  ...defaultState,
  ...getLocalStorage('preferences'),
  show: false,
  inputStyle: defaultState.inputStyle,
  ripple: defaultState.ripple,
  theme: defaultState.theme,
  previousTheme: defaultState.previousTheme,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function reducer(state = initialState, action: any = {}) {
  switch (action.type) {
    case PreferencesActions.UPDATE_SHOW: {
      return {
        ...state,
        show: action.show,
      };
    }
    case PreferencesActions.UPDATE_SCALE: {
      setLocalStorage('preferences', action.scale, 'scale');
      return {
        ...state,
        scale: action.scale,
      };
    }
    case PreferencesActions.UPDATE_MODE: {
      setLocalStorage('preferences', action.mode, 'mode');
      return {
        ...state,
        mode: action.mode,
      };
    }
    case PreferencesActions.UPDATE_COMPACT_GRID: {
      setLocalStorage('preferences', action.compactGrid, 'compactGrid');
      return {
        ...state,
        compactGrid: action.compactGrid,
      };
    }
    default:
      return state;
  }
}
